import agent from '../agent'
import { UPDATE_CURRENT_USER_START, UPDATE_CURRENT_USER_FINISHED, UPDATE_CURRENT_USER, FETCH_CURRENT_USER_START, FETCH_CURRENT_USER_FINISHED } from "../constants/actionTypes"

export const fetchUserStart = () => ({
    type: FETCH_CURRENT_USER_START
})

export const fetchUserFinished = (payload) => ({
    type: FETCH_CURRENT_USER_FINISHED,
    payload
})

export const fetchUserFinishedCommon = (payload) => ({
    type: UPDATE_CURRENT_USER,
    payload
})

export const updateUserStart = () => ({
    type: UPDATE_CURRENT_USER_START
})

export const updateUserFinished = (payload) => ({
    type: UPDATE_CURRENT_USER_FINISHED,
})

export const fetchUser = (userName) => (dispatch) => {
    dispatch(fetchUserStart());
    agent.Auth.current(userName).then(res => {
        dispatch(fetchUserFinished(res));
        dispatch(fetchUserFinishedCommon(res));

    }, err => {
        dispatch(fetchUserFinished(err));
    })
}

export const updateUser = (name,formData) => (dispatch, getState) => {
    let currentState = getState();
    dispatch(updateUserStart());
    agent.Auth.save(name,formData).then(res => {
        dispatch(updateUserFinished());
        const userName = currentState.common && currentState.common.currentUser ? currentState.common.currentUser.userName : null;
        fetchUser(userName)(dispatch);
    }, err => {
        dispatch(updateUserFinished(err));
    })
}